import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useDeleteSystemPlaybook = () => {
  const {
    data: isDeleted,
    call,
    isLoading: isDeleting,
    isFailed: isDeleteFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const deletePlaybook = async (id: string) => {
    await call(`/admin/playbooks/${id}`, "DELETE");
  };

  return { isDeleted, deletePlaybook, isDeleting, isDeleteFailed };
};
